import { useQuery } from '@tanstack/react-query';
import PropTypes from 'prop-types';

import Icon from 'shopper/components/Icon';
import Text from 'shopper/components/Text';

import { commentQueryKeys } from 'lib/queryKeys';

import { getOfferCommentsCount } from 'services/comment';

const Comment = ({ children: count, offerId }) => {
  const { data: commentsCount } = useQuery({
    queryKey: commentQueryKeys.offer.count({ offerId }),
    queryFn: ({ signal }) => getOfferCommentsCount({ offerId }, { signal }),
    select: (data) => {
      // Ensure we always return a number, not an object
      if (typeof data === 'number') return data;
      if (data && typeof data.total === 'number') return data.total;
      return count;
    },
    initialData: count,
  });

  return (
    <div className="flex size-10 items-center justify-center gap-x-1">
      <Icon className="text-rd-primary-700" name="forum" />
      <Text
        as="span"
        className="text-rd-primary-700"
        size="size1"
        type="primary"
        bold
      >
        {commentsCount}
      </Text>
    </div>
  );
};

Comment.propTypes = {
  children: PropTypes.number.isRequired,
  offerId: PropTypes.number.isRequired,
};

export default Comment;
